module.exports = __webpack_public_path__ + "img/1.8.655688e5.png";